export default __webpack_public_path__ + "static/media/LOGO_PRETA.d9eb9018.png";